import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SignUp from '../components/SignUp';
import { CrmButton } from '../components/ui';

export default function UserAccessManagement() {
  const navigate = useNavigate();
  return (
    <div>
      <div style={{ marginBottom: 12 }}><CrmButton variant="secondary" size="small" startIcon={<ArrowBackIcon />} onClick={() => navigate('/users')}>Back to users</CrmButton></div>
      <SignUp hideUsersTab initialTab={1} embedded />
    </div>
  );
}
